import PropTypes from 'prop-types';
import styled from 'helpers/styles';
import ComponentStyles from 'styles/mixins/Component.styles';
import Fab from '@mui/material/Fab';
import constants from 'helpers/constants';
import utils from 'helpers/utils';

const StyledFab = styled(Fab)
  .attrs((props) => {
    let attr = props;

    const vars = {
      '--fab-selected-background-color': props.theme.state2Color(props.color, 'selected', constants.colorTypes.button, constants.colorTargets.background)
    };

    return utils.styleProps(attr, vars);
  })`
  ${props => props.theme.state2Selector('Fab', null, 'selected')} {
    background-color: ${props => props.$css.$var('--fab-selected-background-color')};
  }
  
  &.Fab {
    .Badge {
      .MuiBadge-badge {
        top: -${props => props.theme.layout('0.9sp')};
        right: -${props => props.theme.layout('0.9sp')};
      }
    }
  }
  
  // sizes
  &.Fab-size-larger {
    width: ${props => props.theme.layout(96)};
    height: ${props => props.theme.layout(96)};
  }
  
  ${ComponentStyles}
`;

StyledFab.propTypes = {
  theme: PropTypes.object
};

export default StyledFab;
